import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import useVesselOwnerForm from "./useVesselOwnerFrom";
import { useNavigate } from "react-router-dom";

const defaultForm = {
  state: "",
  city: "",
  country: "",
  address: "",
};

const useFormVessOwner = () => {
  const { formDatas } = useVesselOwnerForm();
  const { token } = useContext(AuthContext);
  
  // Country code mapping for auto-selection
  const countryCodeMap = {
    '+234': 'Nigeria',
    '+1': 'United States',
    '+44': 'United Kingdom',
    '+49': 'Germany',
    '+33': 'France',
    '+39': 'Italy',
    '+34': 'Spain',
    '+31': 'Netherlands',
    '+32': 'Belgium',
    '+41': 'Switzerland',
    '+43': 'Austria',
    '+45': 'Denmark',
    '+46': 'Sweden',
    '+47': 'Norway',
    '+358': 'Finland',
    '+48': 'Poland',
    '+420': 'Czech Republic',
    '+36': 'Hungary',
    '+40': 'Romania',
    '+359': 'Bulgaria',
    '+385': 'Croatia',
    '+386': 'Slovenia',
    '+421': 'Slovakia',
    '+371': 'Latvia',
    '+372': 'Estonia',
    '+370': 'Lithuania',
    '+352': 'Luxembourg',
    '+377': 'Monaco',
    '+378': 'San Marino',
    '+376': 'Andorra'
  };

  // Auto-select country based on phone country code
  const getCountryFromPhoneCode = () => {
    if (formDatas.phoneCountryCode) {
      const countryName = countryCodeMap[`+${formDatas.phoneCountryCode}`];
      return countryName || 'Nigeria';
    }
    return 'Nigeria';
  };

  const [formData, setFormData] = useState({
    ...defaultForm,
    country: getCountryFromPhoneCode()
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    // Validate required fields
    if (!formData.address) {
      setError("Address is required");
      setLoading(false);
      return;
    }
    
    if (!formData.state) {
      setError("State is required");
      setLoading(false);
      return;
    }
    
    if (!formData.city) {
      setError("City is required");
      setLoading(false);
      return;
    }
    
    if (!formData.country) {
      setError("Country is required");
      setLoading(false);
      return;
    }
    
    try {
      const requestData = {
        companyName: formDatas.companyName || "",
        registrationNumber: formDatas.registrationNumber || "",
        address: formData.address,
        state: formData.state,
        city: formData.city,
        country: formData.country,
        phoneNumber: formDatas.phoneNumber || "",
        yearsInOperation: formDatas.yearsInOperation ? parseInt(formDatas.yearsInOperation) : 0,
        website: formDatas.website || "",
        linkedIn: formDatas.linkedIn || "",
        serviceCategory: formDatas.serviceCategory || [],
        keywords: formDatas.keywords || [],
      };

      // console.log(requestData)
  
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData), 
      });
  
      const resData = await res.json();
  
      if (!res.ok) {
        throw new Error(resData.message || "Failed to update profile");
      }
  
      setLoading(false);
      setSuccess("Profile updated successfully");
      setTimeout(() => {
        setSuccess(null);
        navigate("/statutory_v_doc");
      }, 3000);
    } catch (error) {
      setError(error.message || "An error occurred while updating profile");
      setLoading(false);
    }
  };
  

  return {
    handleChange,
    handleSubmit,
    loading,
    formData,
    error,
    success,
  };
};

export default useFormVessOwner;
